import * as React from "react";

const SvgComponent = (props:any) => (
    <svg width={32} height={29} viewBox="0 0 32 29" {...props}>
        <g fillRule="nonzero" fill="none">
            <path
                fill="#444F5C"
                d="M7 22.722h6.199v6.248H7zM7 15.722h6.199v6.246H7z"
            />
            <path
                fill="#4285F4"
                d="M16 12.722h6.247v6.2H16zM25 14.722h6.246v6.199H25zM30.801 9.14l-4.384 4.384L22 9.106l4.385-4.383zM17.385 9.523L13 5.138 17.415.722 21.8 5.106z"
            />
            <path
                fill="#444F5C"
                d="M7 8.722h6.199v6.248H7zM0 15.722h6.02v6.246H0zM6.019 14.97V8.722H1.788c-.987 0-1.788.8-1.788 1.786v4.462h6.019zM6.019 22.722H0v4.46c0 .987.801 1.788 1.788 1.788h4.231v-6.248zM21 22.722v6.248h4.232c.986 0 1.787-.8 1.787-1.789v-4.459H21zM14 22.722h6.2v6.248H14z"
            />
        </g>
    </svg>
);

export default SvgComponent;